// 修复 el‑select ResizeObserver getComputedStyle bug
const original = window.ResizeObserver;
window.ResizeObserver = function(cb) {
    const ro = new original(cb);
    const observe = ro.observe.bind(ro);
    ro.observe = function(el){
        if(!el) return;
        return observe(el);
    }
    return ro;
}